var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 140,
    viewBox: "0 0 165 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LV1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M117.057 47.5476L137.549 43L138.701 43.8268L138.372 55.5679V78.8019C138.372 80.6209 138.372 82.4399 138.372 84.259C138.372 86.078 138.399 87.9246 138.454 89.7988L148 92.1139V96H115V92.1139L125.04 89.7988C125.095 87.9797 125.122 86.1607 125.122 84.3417C125.122 82.4675 125.122 80.6209 125.122 78.8019V51.5991L117.057 52.3432V47.5476Z",
    fill: "url(#paint0_linear_240_2096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.6106 47.08V43H108.971V47.32L102.971 48.28L86.4906 95.72H78.7306L61.5306 47.8L56.8906 47.32V43H82.6506V47.08L75.8506 47.96L86.8106 80.92L97.8506 48.12L91.6106 47.08Z",
    fill: "url(#paint1_linear_240_2096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 47.32V43H47.4V47.32L40.76 47.96C40.7067 51.2133 40.6533 54.52 40.6 57.88C40.6 61.1867 40.6 64.4933 40.6 67.8V72.04C40.6 74.92 40.6 77.9867 40.6 81.24C40.6533 84.44 40.7067 87.6933 40.76 91H54.6L56.76 79.88H63.24L62.44 95.56H21V91.24L27 90.6C27.1067 87.3467 27.16 84.1733 27.16 81.08C27.16 77.9333 27.16 75.0533 27.16 72.44V67.8C27.16 64.4933 27.16 61.1867 27.16 57.88C27.16 54.52 27.1067 51.2133 27 47.96L21 47.32Z",
    fill: "url(#paint2_linear_240_2096)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_2096",
    x1: 15.6078,
    y1: 72.2286,
    x2: 154.479,
    y2: 72.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_2096",
    x1: 18.36,
    y1: 72.56,
    x2: 153.36,
    y2: 72.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_2096",
    x1: 18.36,
    y1: 72.56,
    x2: 153.36,
    y2: 72.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLv1);
export default __webpack_public_path__ + "static/media/lv1.afd7b827d7d0bd82796db77165c593fc.svg";
export { ForwardRef as ReactComponent };